import "./application.css";
import "@hotwired/turbo-rails";
import "../controllers";
import { createApp } from "vue/dist/vue.esm-bundler";
import { createPinia } from "pinia";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
import App from "@/components/views/App.vue";

const pinia = createPinia();
pinia.use(piniaPluginPersistedstate);

const vueComponentConfigs = [
  {
    selector: '[data-app="vue"]',
    component: ["App", App],
  },
];

function mountVueComponents() {
  vueComponentConfigs.forEach(({ selector, component }) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.__vue_app__) return;
      const app = createApp({});
      app.component(...component);
      app.use(pinia);
      app.mount(element);
      element.__vue_app__ = app;
    });
  });
}

document.addEventListener("turbo:load", mountVueComponents);
document.addEventListener("turbo:render", mountVueComponents);
document.addEventListener("DOMContentLoaded", mountVueComponents);
